import { FC, useState } from 'react';
import {
  Box,
  Button,
  Slider,
  Stack,
  Typography,
  Link
} from '@mui/material';
import NearMeIcon from '@mui/icons-material/NearMe';
import { KumaoTheme } from 'src/theme';

interface SearchResultRadiusFilterProps {
  radiusKm: number | null;
  onActivate: (latitude: number, longitude: number) => void;
  onDeactivate: () => void;
  onRadiusChange: (radiusKm: number) => void;
}

const DEFAULT_RADIUS_KM = 25;

const SearchResultRadiusFilter: FC<SearchResultRadiusFilterProps> = (props) => {
  const {
    radiusKm, onActivate, onDeactivate, onRadiusChange
  } = props;
  const [requestingLocation, setRequestingLocation] = useState(false);
  const [locationError, setLocationError] = useState<string | null>(null);

  const handleActivate = () => {
    if (!navigator.geolocation) {
      setLocationError('Dein Browser unterstützt keine Standortabfrage.');
      return;
    }
    setRequestingLocation(true);
    setLocationError(null);
    navigator.geolocation.getCurrentPosition(
      (geoPosition) => {
        setRequestingLocation(false);
        onActivate(geoPosition.coords.latitude, geoPosition.coords.longitude);
      },
      () => {
        setRequestingLocation(false);
        setLocationError('Standortzugriff wurde nicht erlaubt.');
      }
    );
  };

  if (radiusKm === null) {
    return (
      <Box sx={{ backgroundColor: 'white', borderRadius: 5, p: 2, mb: 2 }}>
        <Button
          fullWidth
          color="primary"
          variant="contained"
          startIcon={<NearMeIcon />}
          onClick={handleActivate}
          disabled={requestingLocation}
          sx={{ borderRadius: 5 }}
        >
          {requestingLocation ? 'Standort wird ermittelt…' : 'Umkreissuche'}
        </Button>
        {locationError && (
          <Typography
            sx={{ color: (theme: KumaoTheme) => theme.palette.error.main, fontSize: 'small', mt: 1 }}
          >
            {locationError}
          </Typography>
        )}
      </Box>
    );
  }

  return (
    <Box sx={{ backgroundColor: 'white', borderRadius: 5, p: 2, mb: 2 }}>
      <Typography
        variant="subtitle1"
        sx={{ color: (theme: KumaoTheme) => theme.palette.grey[600], mb: 1 }}
      >
        Umkreissuche
      </Typography>
      <Stack
        spacing={2}
        direction="row"
        alignItems="center"
      >
        <Slider
          value={radiusKm}
          onChange={(event, value) => onRadiusChange(value as number)}
          valueLabelDisplay="auto"
          step={5}
          marks
          min={5}
          max={100}
        />
        <Typography sx={{ minWidth: 48 }}>
          {`${radiusKm} km`}
        </Typography>
      </Stack>
      <Link
        component="button"
        variant="body2"
        onClick={onDeactivate}
        sx={{ mt: 1 }}
      >
        Umkreissuche deaktivieren
      </Link>
    </Box>
  );
};

export { DEFAULT_RADIUS_KM };
export default SearchResultRadiusFilter;
